var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-list" }, [
    _c("table", { staticStyle: { "padding-top": "5px" } }, [
      _c(
        "tbody",
        _vm._l(_vm.participants, function(user) {
          return _c("tr", { key: user.id }, [
            _c("td", { staticStyle: { "text-align": "center" } }, [
              _c("img", {
                staticClass: "img-msg",
                attrs: { src: user.imageUrl }
              })
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "user-element" }, [
              _vm._v(_vm._s(user.name))
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e1bacd30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1bacd30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-beautiful-chat/src/UserList.vue
// module id = 1978
// module chunks = 116